import AsyncAlpine from "async-alpine";
import Alpine from "alpinejs";

import "@@/global.js";
import "@@/theme-editor.js";
import "@@/lazy-image.js";
import "@@/video-player.js";

// Import SCSS
import "../css/lib/old-page-styles-wrapper.scss";

import { cartStore } from "../utils/cart-store";

// Initialize Alpine
window.Alpine = Alpine;

// Register cart store
Alpine.store("cart", cartStore());

AsyncAlpine.init(Alpine);

// Register all components
const components = {
  accordionItem: () => import("../components/accordion-item"),
  announcementBar: () => import("../components/announcement-bar"),
  newSlider: () => import("../components/new-slider"),
  countrySelector: () => import("../components/country-selector"),
  cta: () => import("../components/cta"),
  headerMenu: () => import("../components/header-menu"),
  header: () => import("../components/header"),
  media: () => import("../components/media"),
  overlay: () => import("../components/overlay"),
  pageArchive: () => import("../components/page-archive"),
  productDetailsTabs: () => import("../components/product-details-tabs"),
  productForm: () => {
    return import("../components/product-form");
  },
  relatedProducts: () => import("../components/related-products"),
  search: () => import("../components/search"),
  sizeGuide: () => import("../components/size-guide"),
  sizeGuideDrawer: () => import("../components/size-guide-drawer"),
  variantPicker: () => import("../components/variant-picker"),
  cart: () => import("../components/cart"),
  imageZoomModal: () => import("../components/image-zoom-modal")
};

Object.entries(components).forEach(([name, loader]) => {
  AsyncAlpine.data(name, loader);
});

AsyncAlpine.start();

Alpine.start();

// Theme editor functionality
function hideProductModal() {
  const productModal = document.querySelectorAll("product-modal[open]");
  if (productModal) {
    productModal.forEach((modal) => modal.hide());
  }
}

document.addEventListener("shopify:block:select", function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains("slideshow__slide");
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest("slideshow-component");
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft
    });
  }, 200);
});

document.addEventListener("shopify:block:deselect", function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains("slideshow__slide");
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest("slideshow-component");
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener("shopify:section:load", () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector("[id^=EnableZoomOnHover]");
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement("script");
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener("shopify:section:reorder", () => hideProductModal());
document.addEventListener("shopify:section:select", () => hideProductModal());
document.addEventListener("shopify:section:deselect", () => hideProductModal());
document.addEventListener("shopify:inspector:activate", () => hideProductModal());
document.addEventListener("shopify:inspector:deactivate", () => hideProductModal());
